import React, { useCallback, useState, useEffect } from "react";
import { useQuery, useQueryClient, useMutation } from "react-query";
import moment from "moment";
import { Steps } from "antd";
import srv from "../../../../services";
import { ContentWrapper } from "../../../_common";
import {
  ZoomInIcon,
  ZoomOutIcon,
  RegisteredIcon,
  ProccesingIcon,
  InWorkedIcon,
  ClosedIcon,
  CreatedIcon,
  AnswerIcon,
  QuestionIcon,
} from "../../../_assests";
import {
  Empty,
  Content,
  Appeal,
  AppealData,
  AppealParam,
  AppealContent,
  AppealZoom,
  Messages,
  Message,
  MessageHead,
  MessageDate,
  MessageText,
  ContractZoom,
  TitleStep,
  StepBlockDis,
  StepBlockDone,
} from "./AppealsQuestion.styled";
const { Step } = Steps;

export default function AppealsQuestion() {
  const { appealsQuestion, isLoading, error, maximized, onMaximize } =
    useAppealsQuestion();
  const [currentStep, setCurrentStep] = useState(null);

  useEffect(() => {
    appealsQuestion.forEach((item) => {
      item.eventsHystory.forEach((event, idx) => {
        if (event.createDate !== null) setCurrentStep(idx);
      });
    });
  }, [appealsQuestion]);

  return (
    <ContentWrapper isLoading={isLoading} error={error}>
      {!appealsQuestion?.length ? (
        <Empty>У Вас пока нет отправленных обращений.</Empty>
      ) : (
        <Content>
          {appealsQuestion.map((appeal) => {
            const date = appeal.eventsHystory.map((item) => {
              return item.createDate;
            });
            const status = appeal.eventsHystory.map((item) => {
              return item.eventState;
            });
            return (
              <Appeal
                key={appeal.id}
                maximized={maximized === appeal.id}
                featured={appeal.isNew}
              >
                <ContractZoom onClick={() => onMaximize(appeal)}>
                  {maximized === appeal.id ? <ZoomOutIcon /> : <ZoomInIcon />}
                </ContractZoom>
                <AppealData onClick={() => onMaximize(appeal)}>
                  <AppealParam cols>
                    <span>
                      <u>№ обращения</u>
                      {appeal.requestNumber ? (
                        <b>{appeal.requestNumber}</b>
                      ) : (
                        "На регистрации"
                      )}
                    </span>

                    <span>
                      <u>Обращение</u>
                      Вопрос
                    </span>
                  </AppealParam>

                  <AppealParam>
                    <u>№ договора</u>
                    <b>{appeal.contractNumber}</b>
                  </AppealParam>

                  <AppealParam>
                    <span>
                      <u>Дата создания</u>
                      {moment(appeal.createDate).format("DD.MM.YYYY")}
                    </span>
                  </AppealParam>
                  <AppealParam>
                    <span>
                      <u>Дата и время регистрации обращения</u>
                      {appeal.requestDate !== null
                        ? moment(appeal.requestDate).format("DD.MM.YYYY HH:mm")
                        : "На регистрации"}
                    </span>
                  </AppealParam>
                  <AppealParam cols={appeal.isNew}>
                    <span>
                      <u>Статус</u>
                      {appeal.state}
                    </span>

                    {appeal.isNew && (
                      <span>
                        <u>Новое сообщение</u>
                        <strong>АО «ЕРИЦ ЯНАО»</strong>
                      </span>
                    )}
                  </AppealParam>
                </AppealData>

                {maximized === appeal.id && (
                  <AppealContent>
                    <Messages>
                      <Message>
                        <MessageHead>
                          <MessageDate>
                            Вы {moment(appeal.createDate).format("DD.MM.YYYY")}
                          </MessageDate>
                          <QuestionIcon />
                        </MessageHead>
                        <MessageText>{appeal.message}</MessageText>
                      </Message>

                      {!!appeal?.responseMessage && (
                        <Message answer>
                          <MessageHead>
                            <AnswerIcon />
                            <MessageDate>
                              АО «ЕРИЦ ЯНАО»{" "}
                              {moment(appeal.responseDate || undefined).format(
                                "DD.MM.YYYY"
                              )}
                            </MessageDate>
                          </MessageHead>

                          {!!appeal.responseMessage && (
                            <MessageText>{appeal.responseMessage}</MessageText>
                          )}
                        </Message>
                      )}
                    </Messages>
                    <Steps current={currentStep}>
                      <Step
                        status={status[0] === "Выполняется" ? "finish" : "wait"}
                        title={
                          <TitleStep>
                            <span>Создано</span>
                            {moment(appeal.createDate).format("DD.MM.YYYY")}
                          </TitleStep>
                        }
                        icon={
                          status[0] === "Выполняется" ? (
                            <CreatedIcon />
                          ) : (
                            <StepBlockDone>
                              <CreatedIcon />
                            </StepBlockDone>
                          )
                        }
                      />
                      <Step
                        status={status[1] === "Выполняется" ? "finish" : "wait"}
                        title={
                          <TitleStep>
                            <span>В обработке</span>
                            {date[1] !== null
                              ? moment(date[1]).format("DD.MM.YYYY")
                              : undefined}
                          </TitleStep>
                        }
                        icon={
                          status[1] === "Выполняется" ? (
                            <ProccesingIcon />
                          ) : status[1] === "В ожидании" ? (
                            <StepBlockDis>
                              <ProccesingIcon />
                            </StepBlockDis>
                          ) : (
                            <StepBlockDone>
                              <ProccesingIcon />
                            </StepBlockDone>
                          )
                        }
                      />
                      <Step
                        status={status[2] === "Выполняется" ? "finish" : "wait"}
                        title={
                          <TitleStep>
                            <span>Зарегистрировано</span>
                            {date[2] !== null
                              ? moment(date[2]).format("DD.MM.YYYY")
                              : undefined}
                          </TitleStep>
                        }
                        icon={
                          status[2] === "Выполняется" ? (
                            <RegisteredIcon />
                          ) : status[2] === "В ожидании" ? (
                            <StepBlockDis>
                              <RegisteredIcon />
                            </StepBlockDis>
                          ) : (
                            <StepBlockDone>
                              <RegisteredIcon />
                            </StepBlockDone>
                          )
                        }
                      />
                      <Step
                        status={status[3] === "Выполняется" ? "finish" : "wait"}
                        title={
                          <TitleStep>
                            <span>В работе</span>
                            {date[3] !== null
                              ? moment(date[3]).format("DD.MM.YYYY")
                              : undefined}
                          </TitleStep>
                        }
                        icon={
                          status[3] === "Выполняется" ? (
                            <InWorkedIcon />
                          ) : status[3] === "В ожидании" ? (
                            <StepBlockDis>
                              <InWorkedIcon />
                            </StepBlockDis>
                          ) : (
                            <StepBlockDone>
                              <InWorkedIcon />
                            </StepBlockDone>
                          )
                        }
                      />
                      <Step
                        status={status[4] === "Выполняется" ? "finish" : "wait"}
                        title={
                          <TitleStep>
                            <span>Закрыто</span>
                            {date[4] !== null
                              ? moment(date[4]).format("DD.MM.YYYY")
                              : undefined}
                          </TitleStep>
                        }
                        icon={
                          status[4] === "Выполняется" ? (
                            <ClosedIcon />
                          ) : status[4] === "В ожидании" ? (
                            <StepBlockDis>
                              <ClosedIcon />
                            </StepBlockDis>
                          ) : (
                            <StepBlockDone>
                              <ClosedIcon />
                            </StepBlockDone>
                          )
                        }
                      />
                    </Steps>
                  </AppealContent>
                )}

                <AppealZoom onClick={() => onMaximize(appeal)} />
              </Appeal>
            );
          })}
        </Content>
      )}
    </ContentWrapper>
  );
}

function useAppealsQuestion() {
  const queryClient = useQueryClient();

  const {
    data: appealsQuestion,
    isFetching,
    error,
  } = useQuery<Models.AppealQuestion[]>(
    "appealsQuestion",
    srv.getAppealsQuestion,
    {
      initialData: [],
    }
  );

  const { mutate: markRead } = useMutation(
    (id: number) => srv.markRead("aisAppeals", id),
    {
      onSuccess: () => {
        queryClient.refetchQueries("feature");
        queryClient.refetchQueries("appealsQuestion");
      },
    }
  );

  const [maximized, setMaximized] = useState(null);

  const onMaximize = useCallback(
    (appeal: Models.AppealQuestion) => {
      if (appeal.isNew) {
        markRead(appeal.id);
      }
      if (maximized === appeal.id) {
        setMaximized(null);
      } else {
        setMaximized(appeal.id);
      }
    },
    [markRead, maximized]
  );
  return {
    appealsQuestion,
    isLoading: isFetching && !appealsQuestion?.length,
    error,
    maximized,
    onMaximize,
  };
}
